<!-- Global Search Table -->
<div *ngIf="isVisible">
    <p-table
        #gstable
        [columns]="globalSearchCols"
        [value]="globalSearchData"
        selectionMode="single"
        [style]="{ width: '100%' }"
        dataKey="name"
        [(selection)]="selectedGsProduct"
    >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns">
                    {{ col.header }}
                </th>
                <th class="action p-text-right p-pr-0" style="width: 3rem;">
                    <span class="btnBars p-mr-0">
                        <i class="pi pi-refresh" (click)="refreshList()"></i>
                    </span>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr [pSelectableRow]="rowData">
                <td *ngFor="let col of columns" colspan="2">
                    {{ rowData[col.field] }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
